import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import LogRocket from 'logrocket';
import 'normalize.css';
import './styles/global.scss';
import AppWrapper from './App';
import { storeUTMParams } from './utils/browserUtils';
// import * as serviceWorker from './utils/serviceWorker';

Sentry.init({ dsn: 'https://8241e40a6929464597f79407673e20a6@o174512.ingest.sentry.io/1256393' });
LogRocket.init('rnc1sw/pathrise-splash');
LogRocket.identify({
  context: 'Enrollment Portal',
  vwoRoute: '/apply',
});

storeUTMParams(window.location.href);

ReactDOM.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
